import React from "react";
import ReactDOM from "react-dom/client";
import CommentTextBox from "./Components/CommentTextBox";
import { ContentState, convertFromRaw, convertFromHTML } from "draft-js";

// const rootElement = ReactDOM.createRoot(document.getElementById("root"));
// const value = '{   \"blocks\":[      {         \"key\":\"8br1\",         \"text\":\"Hello Matthew Russell, how are you?\",         \"type\":\"unstyled\",         \"depth\":0,         \"inlineStyleRanges\":[                     ],         \"entityRanges\":[            {               \"offset\":6,               \"length\":15,               \"key\":0            }         ],         \"data\":{                     }      }   ],   \"entityMap\":{      \"0\":{         \"type\":\"mention\",         \"mutability\":\"SEGMENTED\",         \"data\":{            \"mention\":{               \"name\":\"Matthew Russell\",               \"link\":\"https://twitter.com/mrussell247\",               \"avatar\":\"https://pbs.twimg.com/profile_images/517863945/mattsailing_400x400.jpg\",               \"userId\":13            }         }      }   }}'
// rootElement.render(
//   <React.StrictMode>
//     <CommentTextBox Value={JSON.parse(value)} />
//   </React.StrictMode>
// );

const ReactComponents = {
  createCommentTextBoxComponent: (
    dotnetComponentHelper,
    elementRef,
    changeHandlerName,
    currentContentState,
    mentionSearchUrl,
    userToken,
    placeholder,
    readOnly
  ) => {
    const container = ReactDOM.createRoot(document.getElementById(elementRef));

    let contentState = {};

    if (!currentContentState) {
      contentState = null;
    } else {
      try {
        contentState = convertFromRaw(JSON.parse(currentContentState));
      } catch {
        const blocksFromHTML = convertFromHTML(currentContentState);
        contentState = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap
        );
      }
    }

    container.render(
      <React.StrictMode>
        <CommentTextBox
          content={contentState}
          placeholder={placeholder}
          readOnly={readOnly}
          suggestion={{
            url: mentionSearchUrl,
            token: userToken,
            data: [],
          }}
          onChange={(contentState) => {
            let mentionData = [];
            for (let key in contentState.entityMap) {
              const ent = contentState.entityMap[key];
              if (ent.type === "mention") {
                mentionData.push(ent.data.mention);
              }
            }
            const content = {
              rawText: contentState.blocks.map((b) => b.text).join(" "),
              contentState: JSON.stringify(contentState),
              mentionData: mentionData
            };

            dotnetComponentHelper.invokeMethodAsync(
              changeHandlerName,
              JSON.stringify(content)
            );
          }}
        />
      </React.StrictMode>
    );
  },
};

window.ReactComponents = ReactComponents;
